<ng-container [ngSwitch]="iframeType">

  <iframe
    #iframe
    *ngSwitchCase="'normal'"
    [src]="media.urls.full | safeResourceUrl"
  ></iframe>


  <iframe
    #iframe
    *ngSwitchCase="'youtube'"
    [src]="media.urls.full | safeResourceUrl"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    frameborder="0"
    height="100%"
    width="100%"
    referrerpolicy="strict-origin-when-cross-origin"
  ></iframe>


  <iframe
    #iframe
    *ngSwitchCase="'vimeo'"
    [src]="media.urls.full | safeResourceUrl"
    allow="autoplay; fullscreen; picture-in-picture"
    allowfullscreen
    frameborder="0"
    height="100%"
    width="100%"
  ></iframe>

</ng-container>
